export default __webpack_public_path__ + "static/media/faceta_icon_blocklist.358253e9.svg";